import { EntraDefaultRoleScope } from "../../../../autogen/bff-api";

interface Sourcing {
  hasBuyerAccess: boolean;
}

export const newConnectionDefaultRoleScope = ({ hasBuyerAccess }: Sourcing): EntraDefaultRoleScope =>
  hasBuyerAccess ? EntraDefaultRoleScope.DefaultDepartment : EntraDefaultRoleScope.Organization;

export const offersDefaultDepartment = (currentScope: EntraDefaultRoleScope, { hasBuyerAccess }: Sourcing): boolean =>
  hasBuyerAccess || currentScope === EntraDefaultRoleScope.DefaultDepartment;
